import { render, staticRenderFns } from "./CmgMealBuilderOneTapReorder.vue?vue&type=template&id=64debd18&scoped=true&lang=pug"
import script from "./cmg-meal-builder-one-tap-reorder.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-one-tap-reorder.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilderOneTapReorder.vue?vue&type=style&index=0&id=64debd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64debd18",
  null
  
)

export default component.exports